import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import "./CompanyDashboard.css"; 

const CompanyDetailDashboard = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const company = state?.company || { name: 'Croplan Biosciences Pvt Ltd' };

  // Sample Data for both tables
  const newVisits = [
    { name: 'Abhishek Patil', des: 'Sales Officer', count: 9 },
    { name: 'Ajaysinh Shisode', des: 'Sales Officer', count: 24 },
    { name: 'Akshay Murkute', des: 'Field Officer', count: 126 }
  ];

  const followUpVisits = [
    { name: 'Ajaysinh Shisode', des: 'Sales Officer', count: 4 },
    { name: 'Akshay Murkute', des: 'Field Officer', count: 39 },
    { name: 'Nilesh Aswar', des: 'Field Officer', count: 516 }
  ];

  return (
    <div className="container-box">
      {/* Header Section */}
      <div className="header-section">
  <h1 className="main-title">{company.name}</h1>
  

  <div className="breadcrumb-container">
    <span className="breadcrumb-item" onClick={() => navigate('/home')}>Home</span>
    <span className="separator"> / </span>
    <span className="breadcrumb-item" onClick={() => navigate('/dashboard')}>Dashboard</span>
  </div>
</div>

      {/* Table 1: New Field Visits */}
      <div className="table-card">
        <div className="table-title">New Field Visits <span style={{fontSize: '14px', color: '#94a3b8'}}>| Last Year</span></div>
        <table className="custom-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Designation</th>
              <th>New Visits</th>
            </tr>
          </thead>
          <tbody>
            {newVisits?.map((item, i) => (
              <tr key={i}>
                <td className="font-bold">{item.name}</td>
                <td>{item.des}</td>
                <td className="font-bold">{item.count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Table 2: Followup Field Visits */}
      <div className="table-card">
        <div className="table-title">Followup Field Visits <span style={{fontSize: '14px', color: '#94a3b8'}}>| Last Year</span></div>
        <table className="custom-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Designation</th>
              <th>Follow Up</th>
            </tr>
          </thead>
          <tbody>
            {followUpVisits?.map((item, i) => (
              <tr key={i}>
                <td className="font-bold">{item.name}</td>
                <td>{item.des}</td>
                <td className="font-bold">{item.count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CompanyDetailDashboard;